<!-- 操作群时的右侧组件 -->
<template>
    <div class="container">
        <el-drawer :visible.sync="drawerShow" direction="rtl" size="25%" ref="drawer" :with-header="false"
            :destroy-on-close="true" :show-close="false" style="margin-top: 8.0rem">
            <div class="header">
                <div>
                    <el-select v-model="select" slot="prepend" placeholder="请选择" @change="selectChange">
                        <el-option label="群主" value="group_owner"></el-option>
                        <el-option label="群名称" value="group_name"></el-option>
                        <el-option label="群标签" value="group_label"></el-option>
                    </el-select>
                </div>
                <div v-show="select == 'group_owner'" class="input-with-select">
                    <el-cascader clearable v-model="owner" :options="options" :props="{ value: 'userId', label: 'name' }"
                        @change="onChange" placeholder="请选择群主搜索"></el-cascader>
                </div>
                <div v-show="select == 'group_name'" class="input-with-select">
                    <el-input clearable v-model="input" placeholder="请输入群名称搜索" @change="onSearch">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <div v-show="select == 'group_label'" class="input-with-select">
                    <el-cascader clearable v-model="label" :options="options1"
                        :props="{ value: 'id', label: 'tag_name', children: 'children' }" @change="onChange"
                        placeholder="请选择标签搜索"></el-cascader>
                </div>
            </div>
            <div class="menus" v-if="checkbox">
                <el-button type="primary" @click="closeDrawer">确定</el-button>
                <el-button class="clearChoose" type="danger" @click="onClear()">清除选择</el-button>
            </div>
            <div class="container">
                <!-- 多选 -->
                <template v-if="checkbox">
                    <el-table ref="multipleTable" :data="tableData" @selection-change="onSelect" @select="onSelects">
                        <el-table-column type="selection" width="55" :selectable="getDisable"></el-table-column>
                        <el-table-column :label="label1" :prop="prop1"></el-table-column>
                        <el-table-column :label="label2" :prop="prop2"></el-table-column>
                        <el-table-column :label="label3" :prop="prop3"></el-table-column>
                    </el-table>
                </template>
                <!-- 单选 -->
                <template v-else >
                    <el-table style="margin-top: 1rem !important;"  ref="multipleTable" :data="tableData" @current-change="onSelect">
                        <el-table-column width="55">
                            <el-radio :value="0"></el-radio>
                        </el-table-column>
                        <el-table-column :label="label1" :prop="prop1"></el-table-column>
                        <el-table-column :label="label2" :prop="prop2"></el-table-column>
                        <el-table-column :label="label3" :prop="prop3"></el-table-column>
                    </el-table>
                </template>
            </div>
            <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                :page-sizes="[10, 20, 50, 100]" @pagination="getData" />
        </el-drawer>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import Pagination from '@/components/Pagination'
export default {
    name: "rightGroup",
    components: {
        Pagination
    },
    props: {
        checkbox: {  //true多选，false单选
            type: Boolean,
            default: false
        },
        isGroup: {  // 是否为员工群发
            type: Boolean,
            default: false,
        },
        selectData: [Array, Object],
    },
    data() {
        return {
            drawerShow: false,  //控制抽屉是否展示
            select: "group_owner",  //当前搜索字段
            owner: "",  //选择的群主id
            input: "",  //输入框搜索值
            label: "",  //选择的标签id
            options: [],  //群主名称列表
            options1: [],  //标签列表
            prop1: "",  //table第一列展示
            label1: "",
            prop2: "",  //table第二列展示
            label2: "",
            prop3: "",  //table第三列展示
            label3: "",
            tableData: [],  //table数据
            listQuery: {  //页码传参
                page: 1,
                limit: 20,
            },
            total: 0,  //数据总数
            multipleSelection: [],  //选择的数据
        }
    },
    mounted() {
        let userInfo = JSON.parse(window.localStorage.getItem("storuser"));
        this.token = userInfo;
    },
    methods: {
        //打开弹窗
        open() {
            this.drawerShow = true;
            this.getLabelList();
            this.getData();
        },
        //控制列表是否可选
        getDisable(row) {
            if (row.if_sop == "1") {
                return false;
            }
            return true;
        },
        //获取标签列表数据
        async getLabelList() {
            const { data: res } = await this.axios({
                url: "/crm/LabelGroup/getList",
                method: "POST",
                data: qs.stringify({
                    usertoken: this.token.usertoken,
                    account_id: this.token.account_id,
                    phone: this.token.phone,
                }),
            });
            if (res.code == 1) {
                this.options1 = res.data;
            }
        },
        //获取数据
        getData() {
            this.label1 = "群名称";
            this.prop1 = "name"
            this.label2 = "群主";
            this.prop2 = "owner_name";
            this.label3 = "群状态";
            this.prop3 = "status";
            this.axios.post('/crm/Assistant/getClientBaseList', qs.stringify({
                phone: this.token.phone,
                usertoken: this.token.usertoken,
                account_id: this.token.account_id,
                page: this.listQuery.page,
                number_page: this.listQuery.limit,
            }))
                .then(res => {
                    const data = res.data;
                    if (data.code == 1) {
                        this.tableData = data.data.data;
                        this.total = data.data.total;
                        // 以下是为了去重拿到群主名称与userId
                        let arr = [];
                        let newArr = [];
                        let obj = {};
                        arr = data.data.data.map(item => {
                            return {
                                name: item.owner_name,
                                userId: item.owner
                            }
                        })
                        arr.map((item, i) => {
                            if (!obj[arr[i].userId]) {
                                newArr.push(arr[i])
                                obj[arr[i].userId] = TextTrackCue
                            }
                        })
                        this.options = newArr;
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        selectChange() {
            this.input = "";
            this.label = "";
            this.owner = "";
            this.getSearch();
        },
        //搜索执行
        getSearch() {
            let search = '';
            if (this.select == 'group_name') {
                search = this.input;
            } else {
                search = this.label[0];
            }
            this.axios.post('/crm/Assistant/getClientBaseList', qs.stringify({
                phone: this.token.phone,
                usertoken: this.token.usertoken,
                account_id: this.token.account_id,
                page: this.listQuery.page,
                name: search,
                userid: this.owner[0]
            }))
                .then(res => {
                    const data = res.data
                    if (data.code == 1) {
                        this.tableData = data.data.data;
                    }
                }).catch(err => {
                    console.log(err)
                })
        },
        toggleRowSelection() {
            this.$nextTick(() => {
                const rows = this.selectData;
                if (Array.isArray(rows)) {
                    this.multipleSelection = rows;
                    for (let index = 0; index < this.tableData.length; index++) {
                        const element = this.tableData[index];
                        for (let j = 0; j < rows.length; j++) {
                            if (
                                rows[j].id === element.id ||
                                rows[j].id === element.userid ||
                                rows[j].id === element.chat_id
                            ) {
                                this.$refs.multipleTable.toggleRowSelection(element);
                                break;
                            }
                        }
                    }
                }
            });
        },
        //多选不关闭弹窗，单选关闭弹窗
        onSelect(selection) {
            if (this.checkbox) {
                this.multipleSelection = selection;
            } else {
                this.multipleSelection = selection;
                this.closeDrawer();
            }
        },
        //操作表格数据事件
        onSelects(selection, row) {
            //群发的时候选择员工  只有有客户的员工才给出来 一个都没有就提示
            if (this.isGroup) {
                this.axios
                    .post(
                        "/crm/Assistant/ckeckUserContact",
                        qs.stringify({
                            usertoken: this.tooken.usertoken,
                            account_id: this.tooken.account_id,
                            userid: row.userid,
                        }),
                        {
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.code == 1) {
                            // this.multipleSelection.push(row);
                        } else if (res.data.code == 0) {
                            this.$message.error(res.data.msg);
                            this.$refs.multipleTable.toggleRowSelection(row);
                        }
                    })
                    .catch(function (err) { });
            }
        },
        //群名称搜索
        onSearch() {
            this.tableData = [];
            this.getSearch();
        },
        //群主、群标签搜索
        onChange() {
            this.tableData = [];
            this.getSearch();
        },
        //清除选择关闭弹窗
        onClear(rows) {
            this.multipleSelection = [];
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 向父组件传递数据
        closeDrawer() {
            this.$emit("handleSelect", this.multipleSelection);
            this.$refs.drawer.closeDrawer();
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table thead th {
    background-color: #F8F8F8;
}


::v-deep .el-select .el-input {
    width: 10.0rem;
}

::v-deep .input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.input-with-select {
    width: 295px;
  margin-left: 2.0rem;
}

.header {
    display: flex;
    align-items: center;
    padding: 15px;
}

.menus {
    padding: 15px;
  .clearChoose{
    margin-left: 2.0rem !important;
  }
}
::v-deep .el-table .cell{
    text-align: left ;
    padding-right: 0;
}

</style>
